import { css } from '@emotion/core'
//import { mq } from '../../cssInJs'
export default{
    container :{
        maxWidth: '960px',
        margin: 'auto'
    }
}